<template>
  <div class="mcodeApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div @click="$router.go(-1)" class="codeTitle"><i class="el-icon-arrow-left"></i>{{setCode.cinemaName}}</div>
    <div class="codeList">
      <h2>{{setCode.movieName}}</h2>
      <p style="white-space: pre-wrap;line-height:23px;font-size:14px;color:#666">{{setCode.playTime}}</p>
      <p style="white-space: pre-wrap;line-height:23px;font-size:14px;color:#666">{{setCode.hallName}}</p>
      <p style="white-space: pre-wrap;line-height:23px;font-size:14px;color:#666">
        <font v-for="(vo,k) in setCode.d.seatIds">{{vo.name}}</font>
      </p>
    </div>
    <div class="codeList">
      <h3>取电影票
        <span>请扫描二维码取票，多个取票码时请滑动查看</span>
      </h3>
      <div v-for="(item,i) in setCode.ticketCode" class="qrcode">
        <div :id="i+'codes'" class="c"></div>
        <div class="codeTxt">取票码:{{item}}</div>
      </div>
    </div>

    <div class="noty">
      <p>1.请提前到达影院现场，找到自助取票机，打印纸质电影票，完成取票。</p>
      <p>2.如现场自助取票机无法打印电影票，请联系影院工作人员处理。</p>
      <p>3.凭打印好的纸质电影票，检票入场观影。</p>
    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        setCode:[],
      };
    },
    created(){

    },
    beforeMount() {
    },
    mounted() {
      this.beforeMount();
      this.getOrderDetail();
      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },  
      qrcode1:function(id,str){
        setTimeout(function () {
          let qrcode = new QRCode(id, {
              width: 120,
              height: 120, // 高度
              text: str // 二维码内容
          })
        }, 100);
      },
      
      //获取订单详情
      getOrderDetail:function(){
        var that = this;
        var outOrderNo = this.$route.query.outOrderNo;
        //that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/getUserOrderDetail',
          data:{
            outOrderNo:outOrderNo
          },
          dataType:'json',
          success:function(data){
            var tickets = data.data.ticketCode;
              tickets = JSON.parse(tickets);
            for(var i=0;i<tickets.length;i++){
              that.qrcode1(i+'codes',tickets[i]);
            }
            data.data.ticketCode = tickets
            that.setCode = data.data
            
            that.fullscreenLoading = false;
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .mcodeApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
    padding-bottom:5px
  }
  .mcodeApp .codeList{
    width:92%;
    margin:0 auto;
    border-radius:15px;
    background:#fff
  }
  .mcodeApp .codeList h2{
    padding:15px;
    font-size:17px;
  }
  .mcodeApp .codeList p{
    padding: 0 15px 15px 15px;
    line-height:34px;
    color:#333;
    font-size:15px
  }
  .mcodeApp .codeList h3{
    text-align:center;
    padding:15px 0 30px 0
  }
  .mcodeApp .codeList h3 span{
    display:block;
    color:#f00;
    font-size:14px;
    font-weight:400;
    padding-top:8px;
  }

  .mcodeApp .codeTitle{
    width:92%;
    margin:0 auto;
    font-weight:bold;
    font-size:18px;
    padding:15px 0
  }
  .mcodeApp .codeList .qrcode{
    border-bottom:1px #ececec solid;
    padding-bottom:50px;
  }
  .mcodeApp .codeList .qrcode:last-child{
    padding-top:50px;
  }
  .mcodeApp .codeList .qrcode .c{
    margin:0 auto;
    width:120px;
  }
  .mcodeApp .codeList .qrcode .codeTxt{
    text-align:center;
    font-size:15px;
    color:#666;
    padding:10px 0
  }

  .mcodeApp .noty{
    width:90%;
    margin:0 auto;
  }
  .mcodeApp .noty p{
    color:#666;
    font-size:14px;
    padding-top:8px;
    text-align:justify
  }
  

</style>